<section class="hero-section healthcare-hero">

    <div class="hero-bg-circle circle-1"></div>
    <div class="hero-bg-circle circle-2"></div>

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-10 text-center">

                <!-- Industry Label -->
                <div class="offer-pill">
                    {{ 'healthcareHero.eyebrow' | translate }}
                </div>

                <!-- Heading -->
                <h1 class="hero-title">
                    {{ 'healthcareHero.title' | translate | uppercase }}
                </h1>

                <p class="hero-subtitle">
                    {{ 'healthcareHero.subtitle' | translate }}
                </p>

                <!-- Feature Chips -->
                <div class="feature-chips">

                    <span class="feature-chip">
                        <i class="fas fa-calendar-check"></i>
                        {{ 'healthcareHero.appointmentScheduling' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-users"></i>
                        {{ 'healthcareHero.teamScheduling' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fab fa-whatsapp"></i>
                        {{ 'healthcareHero.reminders' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-location-dot"></i>
                        {{ 'healthcareHero.multiLocation' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-check-circle"></i>
                        {{ 'healthcareHero.appointmentApproval' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-user-clock"></i>
                        {{ 'healthcareHero.noShowTracking' | translate }}
                    </span>

                </div>

                <!-- Calls to Action -->
                <div class="hero-actions">

                    <a [routerLink]="'/about-us'" class="btn btn-light hero-btn">
                        {{ 'healthcareHero.learnMore' | translate }}
                    </a>

                    @if (isLoggedIn) {
                    <a [routerLink]="'/app'" class="btn btn-primary hero-btn">
                        {{ 'healthcareHero.getStarted' | translate }}
                    </a>
                    }

                    @if (!isLoggedIn) {
                    <a [routerLink]="'/auth/login'" class="btn btn-primary hero-btn">
                        {{ 'healthcareHero.login' | translate }}
                    </a>

                    <a href="https://clockflex.clfx.in/app/book-appointment/loc/1f63f398-3586-4964-d735-08de574647e3/bt/b588e79b-20d8-4cb8-e478-08de574774b8"
                        target="_blank" rel="noopener noreferrer" class="btn btn-warning hero-btn">
                        {{ 'healthcareHero.bookDemo' | translate }}
                    </a>
                    }

                </div>
            </div>
        </div>
    </div>
</section>